import examples from './examples';

export default {
    name: 'Popover',
    keywords: [
        'tooltip',
        'hover',
        'fly out',
        'toaster',
        'flyout',
    ],
    'see also': [],
    readme: require('./README.md'),
    status: 'experimental',
    componentsSources: [
        {
            name: 'Popover',
            code: require('!raw!./Popover')
        }
    ],
    examples
};



// WEBPACK FOOTER //
// ./../src/Popover/_meta.js